import type { SearchAlertsBannerXinglet } from '@xing-com/crate-jobs-xinglets';

import { SearchAlertBanner } from './components';

export default class Banner implements SearchAlertsBannerXinglet {
  public getComponent(): React.FC {
    return () => <SearchAlertBanner />;
  }
}
